import axios from 'axios';
// REACT_APP_API_URL=http://192.168.1.23:8000/api
// REACT_APP_API_URL=https://backend.katianlogistique.com/api
// Configuration de base d'Axios
// const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://192.168.1.90:8000/api';
// const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://backend.katianlogistique.com/api';
// const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';
// 
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://testapi.katianlogistique.com/api';

console.log('🔗 API Base URL:', API_BASE_URL);

// Client API avec configuration de base
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  withCredentials: false, // Désactivé pour éviter les problèmes CORS en production
});




// Intercepteur pour ajouter le token automatiquement
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('ksl_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Intercepteur pour gérer les réponses et erreurs
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Token expiré, rediriger vers login
      localStorage.removeItem('ksl_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Client API sans authentification (pour les paiements PAL publics)
const apiClientPublic = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  withCredentials: false,
});

// Services d'authentification
export const authAPI = {
  // Connexion
  login: async (email, password) => {
    try {
      const response = await apiClient.post('/auth/login/', {
        email,
        password,
      });
      
      if (response.data.access) {
        localStorage.setItem('ksl_token', response.data.access);
      }
      
      return response.data;
    } catch (error) {
      console.error('❌ Erreur login:', error);
      throw error;
    }
  },

  // Inscription
  register: (userData) => apiClient.post('/auth/register/', userData),

  // Déconnexion
  logout: async () => {
    try {
      await apiClient.post('/auth/logout/');
      localStorage.removeItem('ksl_token');
    } catch (error) {
      console.error('❌ Erreur logout:', error);
      localStorage.removeItem('ksl_token');
    }
  },

  // Vérifier si l'utilisateur est connecté
  isAuthenticated: () => {
    return !!localStorage.getItem('ksl_token');
  },
};


export const tariffAPI = {
  getTariffs: (params = {}) => apiClient.get('/client/tariffs/', { params }),

  calculateShipping: (shipmentData) =>
    apiClient.post('/tariffs/calculate/', shipmentData),
};


export const userAPI = {
  getUsers: (params = {}) => apiClient.get('/users/', { params }),

  getUser: (id) => apiClient.get(`/users/${id}/`),

  createUser: (userData) => apiClient.post('/users/', userData),
  
  createPersonnel: (personnelData) => apiClient.post('/personnel/', personnelData),

  getPersonnel: (params = {}) => apiClient.get('/personnel/', { params }),

  updatePersonnel: (id, personnelData) => apiClient.patch(`/personnel/${id}/`, personnelData),

  updateUser: (id, userData) => apiClient.patch(`/users/${id}/`, userData),

  deleteUser: (id) => apiClient.delete(`/users/${id}/`),

  suspendUser: (id) => apiClient.patch(`/users/${id}`),

  activateUser: (id) => apiClient.post(`/users/${id}/activate/`),

  resetUserPassword: (id) => apiClient.post(`/users/${id}/reset-password/`),

};


// Services de gestion des expéditions
export const expeditionAPI = {
  createExpedition: async (expeditionData) => {
    console.log('📦 [expeditionAPI.createExpedition] → Création expédition:', expeditionData);
    try {
      const response = await apiClient.post('/client/expedition/', expeditionData);
      console.log('✅ Expédition créée:', response.data);
      return response;
    } catch (error) {
      console.error('❌ Erreur création expédition:', error);
      throw error;
    }
  },
 
  // Suivi public par numéro d'expédition (expedition_number) — sans authentification
  // Endpoint dédié : GET /api/public/track/<expedition_number>/
  trackExpedition: async (expedition_number) => {
    const number = (expedition_number || '').trim();
    if (!number) {
      throw new Error('Numéro d\'expédition requis');
    }
    try {
      const response = await apiClientPublic.get(`/public/track/${encodeURIComponent(number)}/`);
      return response;
    } catch (error) {
      console.error('❌ Erreur suivi expédition:', error);
      throw error;
    }
  },

  ExpeditionaPAL: async function(code) {
    console.log(`📦 [expeditionAPI.PAL] → Code de retrait: ${code}`);
    try {
      // Utiliser apiClientPublic car cette recherche est publique (sans authentification)
      const response = await apiClientPublic.get(`/expedition/chekexpedition/`, {
        params: {
          code_retrait: code
        }
      });
      // console.log('✅ Expédition récupérée:', response.data);
      return response;
    } catch (error) {
      console.error('❌ Erreur récupération expédition:', error);
      throw error;
    }
  },

};

//CASHOUT PAL PAIEMENT (DEPOSE L'ARGENT) - Sans authentification
export const cashoutPALpaiementSansContactAPI = {
  initcashoutPALpaimement: (data) => apiClientPublic.post('/paiement/pal/livraison/', data),
  paiementcheckin: (data) => apiClientPublic.post('/paiement/check/', data),
  paiementConfirmation: (transaction_id) => apiClientPublic.get(`/paiement/${transaction_id}/confirm/`),
};

export const TrajetAPI = {
  getTrajets: (params = {}) => apiClient.get('/trajet/', { params }),
  getTrajet: (id) => apiClient.get(`/trajet/${id}/`),
};
// Services de gestion des point realis
export const relayAPI = {
  getAllRelays: async (params = {}) => {
    console.log('🏪 [relayAPI.getAllRelays] → Paramètres:', params);
    try {
      const response = await apiClient.get('/client/pointrelais/', { params });
      console.log('✅ Points relais récupérés:', response.data);
      return response;
    } catch (error) {
      console.error('❌ Erreur récupération points relais:', error);
      throw error;
    }
  },
  
};

// Services de gestion des transporteurs
export const carrierAPI = {
  getAllCarriers: async (params = {}) => {
    console.log('🚛 [carrierAPI.getAllCarriers] → Paramètres:', params);
    try {
      const response = await apiClient.get('/client/transporteur/', { params });
      console.log('✅ Transporteurs récupérés:', response.data);
      return response;
    } catch (error) {
      console.error('❌ Erreur récupération transporteurs:', error);
      throw error;
    }
  },
 
};

//PROMO CODE
export const promoCodeAPI = {
  verifyPromoCode: (data) => apiClient.post('recompense/codepromo/verify/', data),
 };



export const modepaiementAPI = {
  initpaiement: (data) => apiClient.post('/paiement/', data),
  paiementcheckin: (data) => apiClient.post('/paiement/check/', data),

};



export default apiClient; 